import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListingQrCodeComponent } from '../listing-qr-code/listing-qr-code/listing-qr-code.component';

const routes: Routes = [
  {path: '',component: ListingQrCodeComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ListingQrCodeRoutingModule { }
